module.exports = __webpack_public_path__ + "static/media/bg_event.ea2a8e95.png";